export function getSampleCode(detectorId: string) {
  return [
    "from framegrab import FrameGrabber",
    "import groundlight",
    "# 1-time setup",
    "gl = groundlight.Groundlight()",
    `det = gl.get_detector(id="${detectorId}")`,
    "grabber = list(FrameGrabber.autodiscover().values())[0]",
    "# get an image and process it",
    "image = grabber.grab()",
    "gl.ask_confident(det, image)",
  ].join("\n");
}
